export default {
  id: 'topaz',
  nodeType: 'video',
  label: 'Topaz 视频高清放大',
  description: '对输入视频做高清放大、修复、降噪和细节增强。',
}
